import { axiosApiInstance } from "../axios";

export interface TenantInvitationDetails {
  company_name: string;
  tenant_domain: string;
  administrator_name: string;
  username: string;
  email: string;
  expires_at: string;
}

export async function fetchTenantInvitation(token: string) {
  return axiosApiInstance.post<TenantInvitationDetails>(
    "tenant-invitations/inspect",
    { token },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    },
  );
}

export async function acceptTenantInvitation(payload: {
  token: string;
  password: string;
  password_confirmation: string;
}) {
  return axiosApiInstance.post<{ message: string }>(
    "tenant-invitations/accept",
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    },
  );
}
